import { ContactSection } from "../components/Contact";
import { Footer } from "../components/Footer";

export default function Contact() {
  return (
    <main data-testid="contact-page" className="pt-16">
      <ContactSection />
      <Footer />
    </main>
  );
}
